<mat-accordion>
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header class="mb-3">
      <mat-panel-title>
        <div class="navigate-back list-box d-flex justify-content-between">
          <div class="back-arrow">
            <i
              class="bi bi-arrow-left-short cursor-pointer display-6"
              (click)="back()"
              app-stop-propagation
            ></i>
          </div>
          <div class="list-box"></div>
        </div>
        <mat-chip-listbox class="ms-2">
          <!-- current selection PL / WP / PS / M -->
          <mat-chip *ngIf="!solutionService.isSearchResult(); else backToSearch">
            {{ knowledgeBaseService.expandedNodesPath() }}
          </mat-chip>
          <ng-template #backToSearch>
            <span (click)="back()">zurück zur Suche</span>
          </ng-template>
        </mat-chip-listbox>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <!-- Expansion panel -->
    <ng-template matExpansionPanelContent>
      <div
        class="solution-header d-flex justify-content-between mt-3"
        *ngIf="
          this.knowledgeBaseService.activeModule() !== 'downtimeDetails';
          else downtimeDetails
        "
      >
        <!-- heading for solution from knowledge base -->
        <div class="solution-title" *ngIf="solutionService.solution()">
          <span class="qundis-section-heading-h2 mt-3 mb-2">{{
                  solutionService.solution().name
            }}</span>
          <p *ngIf="knowledgeBaseService.activeModule() === 'reportDowntime'">
            Stillstands-ID: {{ reportService.currentReport()?.incident_id }}
          </p>
        </div>
      </div>

      <!-- heading for error report -->
      <ng-template #downtimeDetails>
        @if (userService.userrole() !== Userrole.Mitarbeiter) {
          <div class="action-container d-flex justify-content-end">
            <mat-icon
              matTooltip="Stillstandsmeldung löschen"
              class="cursor-pointer"
              (click)="reportDeletedEvent.emit(reportService.currentReport()!.id)"
            >delete
            </mat-icon>
          </div>
        }
        <!--escalation details-->
        <app-escalation-details
          *ngIf="vm()?.report?.status === MalfunctionStatus.ESCALATED && vmSignal()?.escalation"
          [escalationDetails]="vmSignal()?.escalation!"
          [user]="{id: userService.user()!.id, role: userService.userrole()!}"
          [isUserAssignedToEscalation]="isAssignedToEscalation()"
          (updateEscalationEvent)="updateEscalation({
                        action: $event,
                        escalation: vmSignal()?.escalation!,
                        report: vmSignal()?.report!
                        })"
        >
        </app-escalation-details>


        <div class="col-lg-7 col-xl-8 d-flex flex-column justify-content-between split-panel w-100">

          <div class="d-flex">
            <div class="left-column w-50">
              <!-- left column - report details -->
              <div class="report-heading" *ngIf="solutionService.solution()">
          <span class="qundis-section-heading-h2 my-5">
            <div class="status me-2 mt-3">
              STATUS:
              <span
                [class]="vm()?.report?.status === MalfunctionStatus.SOLVED
                    ? 'text-qundis-primary'
                    : 'text-qundis-warn'
                ">
                <span class="report-status ms-2 me-3">
                  {{ vm()?.report?.status === MalfunctionStatus.SOLVED ? "GELÖST" : "STILLSTAND" }}
                </span>/
                <span class="report-solution ms-3">
                  {{ solutionService.solution().name }}
                </span>
              </span>
            </div>
          </span>
              </div>
              <app-report-details
                [vm]="vmSignal()"
                [downtime]="downtimeExcludingClosure()"
              />
            </div>
            @if (vm()?.report?.status === MalfunctionStatus.ESCALATED) {
              <div class="right-column w-50">
                <div class="col-lg-7 col-xl-8 d-flex flex-column w-100">

                  <!-- Discreet Header -->
                  <div class="comment-section-header mt-3">
                    <span class="comment-title">Aktueller Bearbeitungsstand</span>
                    @if (vm()?.escalation?.assigned_to_user === userService.user()?.id) {
                      <button class="btn-edit-ghost" (click)="editComment() ? saveComment() :
                  editComment.set(!editComment()); setNotificationMessage()">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             stroke-width="2"
                             stroke-linecap="round" stroke-linejoin="round">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                        </svg>
                        {{ editComment() ? 'Speichern' : 'Bearbeiten' }}
                      </button>
                    }
                  </div>

                  <!-- Content Box (Looks like a clean textarea) -->
                  @if (editComment()) {
                    <textarea
                      rows="3"
                      [formControl]="escalationProcessingStatus"
                      (keydown.control.enter)="saveComment()"
                      class="form-control shadow-sm custom-input"
                      placeholder="Status-Update schreiben..."
                    ></textarea>

                    <!--&lt;!&ndash; Send Button (Floating) &ndash;&gt;
                    <div class="position-absolute top-50 end-0 translate-middle-y me-5 mt-4 fade-transition"
                         [class.opacity-50]="escalationProcessingStatus.value?.trim() === ''">
                      <button
                        (click)="saveProcessingStatusNotification()"
                        [disabled]="escalationProcessingStatus.value?.trim() === ''"
                        class="btn btn-qundis-primary btn-sm fw-bold d-flex align-items-center gap-2 px-3">
                        Speichern
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <line x1="22" y1="2" x2="11" y2="13"/>
                          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
                        </svg>
                      </button>
                    </div>-->

                  } @else {
                    <div class="comment-box-display">
                      {{ vmSignal()?.escalation?.processing_status_notification }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>


        </div>

      </ng-template>

      <!-- media items and upload button -->
      <div
        class="content-section solution-media d-flex align-items-center mt-3 mb-4"
      >
        <app-media-item
          *ngFor="let mediaFile of solutionService.mediaFiles()"
          [mediaItem]="mediaFile"
          (click)="
            solutionService.selectedSolutionMediaItem$.next(mediaFile);
            modalService.openModal('mediaSolutionModal')
          "
          (newDeleteEvent)="deleteMediaItem($event)"
          (newEditEvent)="editFilename($event)"
        >
        </app-media-item>
        <div
          class="mediaUpload btn-qundis-primary"
          *ngIf="knowledgeBaseService.activeModule() !== 'downtimeDetails'"
        >
          <label class="upload-area">
            <input
                #mediaInput
                id="mediaUpload"
                class="inputfile"
                type="file"
                accept="image/*, video/*, .pdf"
                (change)="onFileSelected($event)"
                multiple
            />
            <span class="upload-button">
              <i class="bi bi-upload"></i>
            </span>
          </label>
        </div>
      </div>

      <!-- Solution name input field -->
      <div
        class="content-section solution-name mt-3"
        *ngIf="showSolutionNameInput">
        <div class="content-section-heading qundis-section-heading-h2 mb-2">
          Lösungsname:
          <!--          {{ solutionService.solution().name }}-->
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            [formControl]="solutionNameControl"
            placeholder="Lösungsname eingeben (erforderlich)"
            required>
          <small class="text-danger"
                 *ngIf="solutionNameControl.invalid && (solutionNameControl.dirty || solutionNameControl.touched)">
            Lösungsname ist erforderlich
          </small>
        </div>
      </div>

      <!-- solution description -->
      <div
        class="content-section solution-description mt-2"
        [class]="
          vm() && vm()?.report?.status !== MalfunctionStatus.SOLVED ? 'active-downtime' : ''
        "
      >
        <div
          class="content-section-heading qundis-section-heading-h2 mb-3 d-flex align-items-center justify-content-between">
          <span>Lösungsvorgang:</span>
          <section
            *ngIf="showEditSection"
          >
            <div
              class="d-flex justify-content-end"
            >
              <ng-container *ngIf="!solutionService.editSolution(); else saveChanges">
                <!-- Edit solution button when solution exists -->
                <div *ngIf="hasSolution() || knowledgeBaseService.activeModule() === 'knowledgeBase'">
                  <button
                    class="btn btn-qundis-primary"
                    (click)="editSolution()">
                    <span>bearbeiten</span>
                    <i class="bi bi-pencil-square ms-2"></i>
                  </button>
                </div>
              </ng-container>
              <ng-template #saveChanges>
                <button
                  class="btn btn-qundis-primary"
                  (click)="updateSolution();">
                  <span>speichern</span>
                  <i class="bi bi-check-lg ms-2"></i>
                </button>
              </ng-template>
            </div>
          </section>
        </div>
        <div
          *ngIf="!solutionService.editSolution(); else editSolutionDescription"
          [innerHTML]="solutionService.solution().description! | safeHtml"
          class="qundis-inter-400"
        ></div>
      </div>
      <!-- solution prevention -->
      <div
        class="content-section solution-prevention"
        *ngIf="
          solutionService.solution()?.prevention ||
          solutionService.editSolution()
        "
      >
        <div class="content-section-heading qundis-section-heading-h2 mb-2">
          Prävention:
        </div>
        <div
          *ngIf="
            (!solutionService.editSolution() &&
              solutionService.solution()?.prevention) ||
              userService.userrole() === Userrole.Mitarbeiter;
            else editSolutionPrevention
          "
          [innerHTML]="solutionService.solution().prevention! | safeHtml"
        ></div>
      </div>
      <!-- solution additional information -->
      <div
        class="content-section solution-additional-information"
        *ngIf="
          solutionService.solution()?.additional_information ||
          solutionService.editSolution()
        "
      >
        <div class="content-section-heading qundis-section-heading-h2 mb-2">
          Zusatzinformationen:
        </div>
        <div
          *ngIf="
            (!solutionService.editSolution() &&
              solutionService.solution()?.additional_information) ||
              userService.userrole() === Userrole.Mitarbeiter;
            else editSolutionAdditionalInformation
          "
          [innerHTML]="
            solutionService.solution().additional_information! | safeHtml
          "
        ></div>
      </div>

      <ng-template #editSolutionDescription>
        <!--<app-editor
          id="nodeDescription"
          [plugins]="['QundisGPT']"
          [content]="solutionBeingEdited.description"
          (newEditorEvent)="storeEditorData($event, editorData$)"
        ></app-editor>-->
        <app-ai-editor [editorData]="solutionBeingEdited.description"
                       (newEditorEvent)="storeEditorData($event, editorData$)"></app-ai-editor>
      </ng-template>

      <ng-template #editSolutionPrevention>
        <app-editor
          id="solutionPrevention"
          [placeholder]="'Prävention'"
          [content]="solutionBeingEdited.prevention"
          (newEditorEvent)="storeEditorData($event, solutionPrevention$)"
        ></app-editor>
      </ng-template>

      <ng-template #editSolutionAdditionalInformation>
        <app-editor
          id="solutionAdditionalInformation"
          [placeholder]="'Zusätzliche Informationen'"
          [content]="solutionBeingEdited.additional_information"
          (newEditorEvent)="
            storeEditorData($event, solutionAdditionalInformation$)
          "
        ></app-editor>
      </ng-template>
      <section
        class="workflow-buttons mt-5 active-report-options d-flex justify-content-between"
        *ngIf="showWorkflowButtons()"
      >

        <div class="left-container d-flex flex-column gap-2">
          @if (hasSolution()) {
            <button

              class="btn btn-qundis-primary"
              (click)="addNewSolution()"
            >
            <span class="d-flex justify-content-center">
              <mat-icon class="me-2">add</mat-icon>
              Neue Lösung verfassen
            </span>
            </button>
            <app-select-solution-button
              [availableSolutions]="availableSolutions()"
              (solutionSelected)="selectSolution($event)"
            />
          }
        </div>
        <div class="right-container d-flex align-items-end">
          <div class="d-flex justify-content-end">
          </div>
          <button *ngIf="hasSolution(); else createNewSolution"
                  class="btn btn-qundis-primary"
                  (click)="solveReport()">
            Behoben
          </button>
          <ng-template #createNewSolution>
            <app-select-solution-button
              [availableSolutions]="availableSolutions()"
              (solutionSelected)="selectSolution($event)"
            />
            <button
              class="btn btn-qundis-primary me-3"
              (click)="
          solutionBeingEdited$.next(solutionService.solution());
          solutionService.editSolution.set(true);
        ">
              <i class="bi bi-plus-circle me-2"></i>
              <span>Lösung erstellen</span>
            </button>
          </ng-template>
          <button *ngIf="knowledgeBaseService.activeModule() == 'downtimeDetails' " class="btn btn-qundis-escalate ms-3"
                  (click)="modalService.openModal('escalationModal')">
            Stillstand eskalieren
          </button>
        </div>
      </section>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #noSolutionsFound>
  <div class="row bg-light rounded p-2 mb-2">
    <div class="col col-auto">
      <div class="row">
        <p>Keine Lösungen vorhanden</p>
      </div>
    </div>
  </div>
</ng-template>
